import {
  createSurfaceMotion,
  installInteractionMotion,
  motionPresets
} from "./chunk-5FU5GH5G.js";

// src/appearance.ts
var appearanceKey = "iden:workspace:appearance";
var getWorkspaceTheme = () => {
  if (typeof window === "undefined") {
    return "light";
  }
  const systemTheme = typeof window.matchMedia === "function" && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  try {
    const mode = localStorage.getItem(appearanceKey);
    return mode === "light" || mode === "dark" ? mode : systemTheme;
  } catch {
    return systemTheme;
  }
};
var persistWorkspaceAppearance = (mode) => {
  try {
    localStorage.setItem(appearanceKey, mode);
    window.dispatchEvent(new Event("iden:appearance-change"));
  } catch {
  }
};
var observeWorkspaceAppearance = (listener) => {
  const onStorage = (event) => {
    if (event.key === appearanceKey) {
      listener();
    }
  };
  window.addEventListener("storage", onStorage);
  window.addEventListener("iden:appearance-change", listener);
  return () => {
    window.removeEventListener("storage", onStorage);
    window.removeEventListener("iden:appearance-change", listener);
  };
};
var synchronizeAppearance = (theme) => {
  Reflect.set(document.documentElement.dataset, "theme", theme);
  for (const frame of document.querySelectorAll("iframe[data-iden-help]")) {
    frame.contentWindow?.postMessage({ type: "iden:appearance", theme }, window.location.origin);
  }
};
var readParentAppearance = (apply) => {
  const listener = (event) => {
    if (event.source !== window.parent || event.origin !== window.location.origin || !event.data || typeof event.data !== "object") {
      return;
    }
    const type = Reflect.get(event.data, "type");
    const theme = Reflect.get(event.data, "theme");
    if (type === "iden:appearance" && (theme === "light" || theme === "dark")) {
      apply(theme);
    }
  };
  window.addEventListener("message", listener);
  return () => {
    window.removeEventListener("message", listener);
  };
};

// src/elements.ts
var elementFoundationCss = `
  :host {
    --iden-element-bg: var(--iden-surface, #ffffff);
    --iden-element-text: var(--iden-text, #15242b);
    --iden-element-muted: var(--iden-muted, #536973);
    --iden-element-accent: var(--iden-accent, #007c91);
    --iden-element-line: var(--iden-line, #d9e3e7);
    --iden-element-font: var(--iden-font, 'Manrope Variable', system-ui, sans-serif);
    box-sizing: border-box;
  }
  @media (prefers-color-scheme: dark) {
    :host {
      --iden-element-bg: var(--iden-surface, #181e24);
      --iden-element-text: var(--iden-text, #e6eff2);
      --iden-element-muted: var(--iden-muted, #a0b2bd);
      --iden-element-accent: var(--iden-accent, #67e8f9);
      --iden-element-line: var(--iden-line, #30404b);
    }
  }
  :focus-visible { outline: 2px solid var(--logto-color-primary, var(--iden-element-accent)); outline-offset: 3px; }
`;
export {
  createSurfaceMotion,
  elementFoundationCss,
  getWorkspaceTheme,
  installInteractionMotion,
  motionPresets,
  observeWorkspaceAppearance,
  persistWorkspaceAppearance,
  readParentAppearance,
  synchronizeAppearance
};
